import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.options,"required":_vm.required,"disabled":_vm.disable,"item-value":"id","item-text":"name","label":_vm.$t('pages.projectForm.branch'),"clearable":_vm.clearable && !_vm.required},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }